import axios from 'axios'
import qs from 'qs'
import {analytics} from '@/app/js/analytics'

export function initCoupons() {
  const couponEls = document.querySelectorAll('.js-coupon')

  couponEls.forEach(initCoupon)
}

export function initCoupon(couponEl) {
  const inputEl = couponEl.querySelector('.js-coupon-value')
  const buttonEl = couponEl.querySelector('.js-coupon-add')

  buttonEl.addEventListener('click', () => {
    axios({
      method: 'post',
      headers: {'content-type': 'application/x-www-form-urlencoded'},
      url: '/index.php?route=extension/total/coupon/coupon',
      data: qs.stringify({
        coupon: inputEl.value
      }),
    })
      .then(() => {
        analytics.promoCodeActivated(inputEl.value)

        window.location.reload()
      })
  })
}
